/* eslint-disable */
import { WebApi } from "@/services/WebApi"

const state = () => ({
    preferredResources: [],
    loadingPreferredResources: false,
    retryPreferredResources: false
})

const mutations = {
    setPreferredResources(state, preferredResources) {
        state.preferredResources = preferredResources.map(({ petId, value }) => {
            const parsedValue = JSON.parse(value);
            return {
                petId,
                resourceId: parsedValue.id
            }
        });
    },
    setLoading(state, loading) {
        state.loadingPreferredResources = !!loading;
    },
    setRetry(state, retry) {
        state.retryPreferredResources = !!retry;
    }
}

const actions = {
    getPreferredResourcesBySiteId({ commit }, siteId) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            WebApi.get('Portal/'+ siteId +'/PreferredResource')
                .then(response => {
                    commit('setPreferredResources', response.data);
                    resolve(response);
                })
                .catch(error => {
                    commit('setRetry', true);
                    reject(error);
                })
                .finally (() => {
                    commit('setLoading', false);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}